import styled from "styled-components";
import {
  colors,
  spacings,
  borders,
  fontSizes,
} from '../../styles/theme'

export const Container = styled.div`
  background: ${colors.white};
  padding: ${spacings.ls};
  border-radius: ${borders.lg};

  & + & {
    margin-top: ${spacings.lg};
  }
`

export const TableSearch = styled.form`
  display: flex;
  width: 50%;
  margin-bottom: ${spacings.lg};

  button{
    margin-left: ${fontSizes.xl};
  }
`
